<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <rect class="cls-3" x="-.04" y="-.04" width="90.07" height="90.07"/>
  <path class="cls-2" d="m5.6,18.63l15.64,4.56c.99.29,1.76,1.07,2.04,2.06l9.66,34.27c.36,1.29,1.54,2.18,2.87,2.18h29.13c1.24,0,2.35-.77,2.79-1.93l9.8-25.85c.74-1.95-.7-4.05-2.79-4.05H30.6"/>
  <circle class="cls-1" cx="39.14" cy="70.62" r="4.37"/>
  <circle class="cls-1" cx="62" cy="70.62" r="4.37"/>
  <g>
    <g>
      <circle class="cls-3" cx="51.62" cy="45.1" r="9.7"/>
      <path class="cls-4" d="m51.62,55.48c-5.72,0-10.38-4.66-10.38-10.38s4.66-10.38,10.38-10.38,10.38,4.66,10.38,10.38-4.66,10.38-10.38,10.38Zm0-19.41c-4.98,0-9.03,4.05-9.03,9.03s4.05,9.03,9.03,9.03,9.03-4.05,9.03-9.03-4.05-9.03-9.03-9.03Z"/>
    </g>
    <path class="cls-4" d="m51.62,38.63c-.09,0-.17-.08-.17-.17v-1.48c0-.09.08-.17.17-.17s.17.08.17.17v1.48c0,.09-.08.17-.17.17Z"/>
    <g>
      <line class="cls-3" x1="45.88" y1="39.36" x2="46.44" y2="39.92"/>
      <path class="cls-4" d="m46.44,40.09s-.09-.02-.12-.05l-.56-.56c-.07-.07-.07-.17,0-.24s.17-.07.24,0l.56.56c.07.07.07.17,0,.24-.03.03-.08.05-.12.05Z"/>
    </g>
    <g>
      <line class="cls-3" x1="43.5" y1="45.1" x2="44.98" y2="45.1"/>
      <path class="cls-4" d="m44.98,45.27h-1.48c-.09,0-.17-.08-.17-.17s.08-.17.17-.17h1.48c.09,0,.17.08.17.17s-.08.17-.17.17Z"/>
    </g>
    <g>
      <line class="cls-3" x1="46.12" y1="50.6" x2="46.68" y2="50.04"/>
      <path class="cls-4" d="m46.12,50.77s-.09-.02-.12-.05c-.07-.07-.07-.17,0-.24l.56-.56c.07-.07.17-.07.24,0s.07.17,0,.24l-.56.56s-.08.05-.12.05Z"/>
    </g>
    <g>
      <line class="cls-3" x1="51.62" y1="53.22" x2="51.62" y2="51.74"/>
      <path class="cls-4" d="m51.62,53.39c-.09,0-.17-.08-.17-.17v-1.48c0-.09.08-.17.17-.17s.17.08.17.17v1.48c0,.09-.08.17-.17.17Z"/>
    </g>
    <g>
      <line class="cls-3" x1="57.12" y1="50.6" x2="56.56" y2="50.04"/>
      <path class="cls-4" d="m57.12,50.77s-.09-.02-.12-.05l-.56-.56c-.07-.07-.07-.17,0-.24s.17-.07.24,0l.56.56c.07.07.07.17,0,.24-.03.03-.08.05-.12.05Z"/>
    </g>
    <g>
      <line class="cls-3" x1="59.74" y1="45.1" x2="58.26" y2="45.1"/>
      <path class="cls-4" d="m59.74,45.27h-1.48c-.09,0-.17-.08-.17-.17s.08-.17.17-.17h1.48c.09,0,.17.08.17.17s-.08.17-.17.17Z"/>
    </g>
    <g>
      <line class="cls-3" x1="57.12" y1="39.36" x2="56.56" y2="39.92"/>
      <path class="cls-4" d="m56.56,40.09s-.09-.02-.12-.05c-.07-.07-.07-.17,0-.24l.56-.56c.07-.07.17-.07.24,0s.07.17,0,.24l-.56.56s-.08.05-.12.05Z"/>
    </g>
    <g>
      <line class="cls-3" x1="43.5" y1="45.1" x2="44.98" y2="45.1"/>
      <path class="cls-4" d="m44.98,45.27h-1.48c-.09,0-.17-.08-.17-.17s.08-.17.17-.17h1.48c.09,0,.17.08.17.17s-.08.17-.17.17Z"/>
    </g>
    <g>
      <line class="cls-3" x1="51.62" y1="53.22" x2="51.62" y2="51.74"/>
      <path class="cls-4" d="m51.62,53.39c-.09,0-.17-.08-.17-.17v-1.48c0-.09.08-.17.17-.17s.17.08.17.17v1.48c0,.09-.08.17-.17.17Z"/>
    </g>
    <g>
      <line class="cls-3" x1="59.74" y1="45.1" x2="58.26" y2="45.1"/>
      <path class="cls-4" d="m59.74,45.27h-1.48c-.09,0-.17-.08-.17-.17s.08-.17.17-.17h1.48c.09,0,.17.08.17.17s-.08.17-.17.17Z"/>
    </g>
    <g>
      <polyline class="cls-3" points="49.6 39.97 51.62 45.1 56.84 47.51"/>
      <path class="cls-5" d="m56.84,48.02c-.07,0-.14-.01-.21-.05l-5.4-2.5-2.1-5.32c-.1-.26.03-.56.29-.66.26-.1.56.02.66.29l1.95,4.94,5.03,2.33c.25.12.37.42.25.67-.09.19-.27.29-.46.29Z"/>
    </g>
  </g>
</svg>
</template>

<script>
export default {
    name: "TimeSalesTableIcon",
}
</script>

<style scoped>
  .cls-1 {
    stroke-width: 2.5px;
  }
  .cls-1, .cls-2 {
    fill: none;
    stroke: #59c5c7;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .cls-3 {
    fill: #fff;
  }
  .cls-4 {
    fill: #0f5b71;
  }
  .cls-5 {
    fill: #59c5c7;
  }
  .cls-2 {
    stroke-width: 3.5px;
  }
</style>